

import React, { StrictMode, useEffect } from 'react'
import ReactDOM from 'react-dom/client'

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  BrowserRouter,
  extendTheme
} from "react-router-dom";

import App from './pages/App'
import HomePage from './pages/Home'
import SettingsPage from './pages/Settings'
import VideoListPage from './pages/videoCRUD/VideoList'
import UsersListPage from './pages/usersCRUD/UsersList'
import CompetitionsListPage from './pages/competitionsCRUD/CompetitionsList'
import CategoriesList from './pages/categoriesCRUD/CategoriesList'
import SortCategories from './pages/categoriesCRUD/SortCategories'
import SortVideos from './pages/videoCRUD/SortVideos'
import PodcastListPage from './pages/podcastCRUD/PodcastList'
import PalmaresListPage from './pages/palmaresCRUD/PalmaresList'
import NotificationsPage from './pages/Notifications'
import LoginPage from './pages/Login'
import { ChakraProvider } from '@chakra-ui/react'
import SidebarWithHeader from './components/sidebar'
import { StatusProvider } from './commonContext'
import theme from './theme'
import TermsAndConditions from './pages/TermsAndConditions';
import TrainingsList from './pages/trainingsCRUD/TrainingsList';
import ExternalusersList from './pages/externalusersCRUD/ExternalusersList';
import CalendarPage from './pages/trainingsCRUD/CalendarPage';
import NewTrainingSheet from './pages/trainingsCRUD/NewTrainingSheet';
import TrainingSheets from './pages/trainingsCRUD/TrainingSheets';
import EditTrainingSheet from './pages/trainingsCRUD/EditTrainingSheet';
import UserAddSheet from './pages/usersCRUD/UserAddSheet';

// Render our app!
const rootElement = document.getElementById('root')
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)


  let currentUser = JSON.parse(localStorage.getItem('currentUser'))
  let logged = currentUser !== null && currentUser !== undefined && currentUser !== "" ? true : false
  console.log("logged: ", logged)


  root.render(

    <StrictMode>
      <StatusProvider children={
        <ChakraProvider theme={theme}>
          {logged && <SidebarWithHeader  >
            <BrowserRouter>
              <Routes >
                <Route path="/" element={<HomePage />} />
                <Route path="/categorieslist" element={<CategoriesList />} />
                <Route path="/sortCategories" element={<SortCategories />} />
                <Route path="/videolist" element={<VideoListPage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/users" element={<UsersListPage />} />
                <Route path="/competitions" element={<CompetitionsListPage />} />
                <Route path="/sortVideos" element={<SortVideos />} />
                <Route path="/podcast" element={<PodcastListPage />} />
                <Route path="/palmares" element={<PalmaresListPage />} />
                <Route path="/termsandconditions" element={<TermsAndConditions />} />
                <Route path="/trainings" element={<TrainingsList />} />
                <Route path="/externalusers" element={<ExternalusersList />} />
                <Route path="/calendarPage" element={<CalendarPage />} />
                <Route path="/newtrainingsheet" element={<NewTrainingSheet />} />
                <Route path="/trainingsheets" element={<TrainingSheets />} />
                <Route path="/edittrainingsheet" element={<EditTrainingSheet />} />
                <Route path="/useraddsheet" element={<UserAddSheet />} />
              </Routes>
            </BrowserRouter>
          </SidebarWithHeader>}
          {!logged &&
            <BrowserRouter>
              <Routes >
                <Route path="/" element={<LoginPage />} />
                <Route path="/termsandconditions" element={<TermsAndConditions />} />
              </Routes>
            </BrowserRouter>
          }
        </ChakraProvider>
      } />
    </StrictMode>,
  )
}



/* OLD, before routing */
/* import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); */
